import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetAppMessageRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetAppMessageResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getAppMessage = (request: GetAppMessageRequest, options?: CashRequestOptions) =>
  post<GetAppMessageRequest, GetAppMessageResponse>('/2.0/cash/get-app-message', request, {
    ...options,
    rejectOnError: true,
  })
